import { useMutation } from '@tanstack/react-query'

import * as api from '../api'
import useInvalidate from '../useInvalidate'

export default function useCancelScheduledCourseEventBooking() {
  const invalidate = useInvalidate()

  return useMutation({
    mutationFn: async ({ eventUuid, userUuid }: { eventUuid: string; userUuid: string }) => {
      await api.del(`booking/scheduled-course/${eventUuid}`, { user_uuid: userUuid })

      invalidate.courses()
      invalidate.userLearningAssignments()
    },
  })
}
